import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'

import { Link, SecondaryButton } from '@aok/ui-elements'
import { ArrowRoundedRightup, EasyLanguage, SignLanguage } from '@aok/icon-functional'

import SearchAutocomplete from '../../molecules/SearchAutocomplete/SearchAutocomplete'

import { handleAutocompleteRequest } from '../../../utils/requests/handleAutocompleteRequest'
import { getEnvironment } from '../../../utils/appUtils'

import { APIContext } from '../../../context/APIContext'
import { openUrl } from '../../../utils/UrlUtils'
import { withPrefix } from 'gatsby-link'

const MobileMenu = ({ fixedLinks, mainMenu, tags, onSubmitSearch }) => {
  const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false)

  const apiContext = useContext(APIContext)
  const [api] = useState({
    autocompleteUrl: apiContext[getEnvironment('AUTOCOMPLETE_URL') || ''],
    frequentlySearchedUrl: apiContext[getEnvironment('FREQUENTLY_SEARCHED_URL') || ''],
  })

  const handleRequestAutocompleteData = (query, successCallback) => {
    handleAutocompleteRequest(api.autocompleteUrl, query, successCallback)
  }

  const submitSearch = (value) => {
    if (!value) {
      return
    }

    let searchParams = new URLSearchParams()
    value = value.replaceAll('&', 'und')
    searchParams.set('q', value)
    const completeUrl = withPrefix(`/suche/?${searchParams.toString()}`)
    openUrl(completeUrl)

    onSubmitSearch()
  }

  return (
    <div data-tracking-name="mobile-menu">
      <SearchAutocomplete
        autocompleteProps={{
          variant: 'light',
        }}
        searchFieldProps={{
          id: 'mobile-header-searchField-input',
          labelVisibility: 'hide',
          inputProps: {
            placeholder: 'Wonach suchen Sie?',
          },
          variant: 'light',
        }}
        setIsAutocompleteOpen={setIsAutocompleteOpen}
        onSubmit={submitSearch}
        onSelect={submitSearch}
        onRequestAutocompleteData={handleRequestAutocompleteData}
      />

      {!isAutocompleteOpen && (
        <>
          {/* Main menu */}
          <ul className="mt-16 600:grid 600:grid-cols-2 600:gap-x-16 720:gap-x-24">
            {mainMenu.map((item, index) => (
              <li key={index} className="relative group">
                <a
                  href={item.url}
                  className="mainMenuItem block
                    px-8 pt-18 pb-16
                    text-16 leading-24 text-293033
                    group-hover:font-semibold focus:font-semibold
                    group-hover:text-005e3f focus:text-005e3f
                    after:focus:bg-left
                  "
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>

          {/* Tags */}
          <p className="mt-32 text-6d767c">Aktuelle Themen</p>
          <div className="flex flex-wrap -ml-16">
            {tags.map((tag, index) => (
              <SecondaryButton key={index} url={tag.url} className="mt-16 ml-16">
                {tag.title}
              </SecondaryButton>
            ))}
          </div>

          {/* Link to Frontpage */}
          <Link
            href={fixedLinks?.start?.url}
            title={fixedLinks?.start?.title}
            target="_blank"
            theme="secondary"
            className="mt-32"
            icon={<ArrowRoundedRightup />}
          />
        </>
      )}

      <hr className="mt-32 border-0 border-t-2 border-dfe3e6" />

      <div className="mt-32 flex flex-col gap-16 600:flex-row 600:gap-32 600:items-center 600:justify-center">
        <Link
          href={fixedLinks?.easyLanguage?.url}
          title={fixedLinks?.easyLanguage?.title}
          theme="secondary"
          icon={<EasyLanguage />}
          iconPosition="left"
        />

        <Link
          href={fixedLinks?.signLanguage?.url}
          title={fixedLinks?.signLanguage?.title}
          theme="secondary"
          icon={<SignLanguage />}
          iconPosition="left"
        />
      </div>
    </div>
  )
}

MobileMenu.propTypes = {
  mainMenu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  fixedLinks: PropTypes.shape({
    easyLanguage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    signLanguage: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    start: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
}

MobileMenu.defaultProps = {
  mainMenu: [],
  tags: [],
}

export default MobileMenu
